// extracted by mini-css-extract-plugin
module.exports = {"securityCheckSign":"styles_securityCheckSign__pmu0p"};